import { makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles";

const useStyles = makeStyles((theme: Theme) => ({
    leftSide: {},

    rightSide: {
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "flex-start",
        flexDirection: "column",
        width: "100%",
        padding: theme.direction === "ltr" ? "0px 0px 0px 40px" : "0px 40px 0px 0px",
    },

    mobile_rightSide: {
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "flex-start",
        flexDirection: "column",
        padding: "0px",
    },

    close_container: {
        cursor: "pointer",
        position: "absolute",
        top: "70px",
        right: theme.direction === "ltr" ? 30 : "none",
        left: theme.direction === "rtl" ? 30 : "none",
    },
}));

export default useStyles;
